import { msg } from '@lingui/core/macro';

const tt = v => new StringProxy(v);

function StringProxy(value) { this.value = value; }
StringProxy.prototype.toString = function proxyToString() {
  return window.i18n._(this.value);
};

// Strands
export const NUMBER_ALGEBRA = 'number&algebra';
export const STATISTICS_DATA = 'statistics&data';
export const CHANCE_PROBABILITY = 'chance&probability';
export const GEOMETRY = 'geometry';
export const MEASUREMENT = 'measurement';

// Substrands
export const ADDITION_SUBTRACTION = 'addition&subtraction';
export const MULTIPLICATION_DIVISION = 'multiplication&division';
export const FRACTIONS = 'fractions';
export const DECIMALS = 'decimals';
export const PERCENTAGES = 'percentages';
export const INDICES = 'indices';
export const OPERATIONS = 'operations';
export const RATES_RATIOS = 'rates&ratios';
export const NUMBERTHEORY = 'numbertheory';
export const MONEY = 'money';
export const WHOLENUMBER = 'wholenumber';
export const PATTERNS = 'patterns';
export const EQUATIONS_EXPRESSIONS = 'equations&expressions';
export const LOGARITHMS = 'logarithms';
export const N_A_GENERAL = 'general';

export const THREEDSHAPE = '3dshape';
export const TWODSHAPE = '2dshape';
export const SYMMTRANS_LOCN = 'symmtrans&locn';
export const ANGLE = 'angle';
export const GEOMETRICPROOFS = 'geometricproofs';

export const TIME = 'time';
export const AREA = 'area';
export const LENGTH = 'length';
export const MASS = 'mass';
export const VOLUME_CAPACITY = 'volume&capacity';
export const TEMPERATURE = 'temperature';
export const PYTHAGORAS_TRIG = 'pythagoras&trig';
export const MEAS_GENERAL = 'general';

export const SUB_STRAND_COLOURS = {
  [NUMBER_ALGEBRA]: '#FF4949',
  [STATISTICS_DATA]: '#A14AD9',
  [CHANCE_PROBABILITY]: '#EA5100',
  [GEOMETRY]: '#0878A8',
  [MEASUREMENT]: '#4B8400'
};

export const strands = {
  [NUMBER_ALGEBRA]: {
    title: tt(msg`Number & Algebra`),
    colour: '#E27B7B',
    substrands: [
      ADDITION_SUBTRACTION,
      MULTIPLICATION_DIVISION,
      FRACTIONS,
      DECIMALS,
      PERCENTAGES,
      INDICES,
      OPERATIONS,
      RATES_RATIOS,
      NUMBERTHEORY,
      MONEY,
      WHOLENUMBER,
      PATTERNS,
      EQUATIONS_EXPRESSIONS,
      LOGARITHMS,
      N_A_GENERAL
    ]
  },
  [STATISTICS_DATA]: {
    title: tt(msg`Statistics & Data`),
    colour: '#b777E0',
    substrands: []
  },
  [CHANCE_PROBABILITY]: {
    title: tt(msg`Chance & Probability`),
    colour: '#FFB100',
    substrands: []
  },
  [GEOMETRY]: {
    title: tt(msg`Geometry`),
    colour: '#48AFDB',
    substrands: [
      THREEDSHAPE,
      TWODSHAPE,
      SYMMTRANS_LOCN,
      ANGLE,
      GEOMETRICPROOFS
    ]
  },
  [MEASUREMENT]: {
    title: tt(msg`Measurement`),
    colour: '#84C62D',
    substrands: [
      TIME,
      AREA,
      LENGTH,
      MASS,
      VOLUME_CAPACITY,
      TEMPERATURE,
      PYTHAGORAS_TRIG,
      MEAS_GENERAL
    ]
  }
};

export const substrands = {
  [ADDITION_SUBTRACTION]: tt(msg`Addition & Subtraction`),
  [MULTIPLICATION_DIVISION]: tt(msg`Multiplication & Division`),
  [FRACTIONS]: tt(msg`Fractions`),
  [DECIMALS]: tt(msg`Decimals`),
  [PERCENTAGES]: tt(msg`Percentages`),
  [INDICES]: tt(msg`Indices`),
  [OPERATIONS]: tt(msg`Operations`),
  [RATES_RATIOS]: tt(msg`Rates & Ratios`),
  [NUMBERTHEORY]: tt(msg`Number Theory`),
  [MONEY]: tt(msg`Money`),
  [WHOLENUMBER]: tt(msg`Whole Number`),
  [PATTERNS]: tt(msg`Patterns`),
  [EQUATIONS_EXPRESSIONS]: tt(msg`Equations & Expressions`),
  [LOGARITHMS]: tt(msg`Logarithms`),
  [N_A_GENERAL]: tt(msg`General`),
  [THREEDSHAPE]: tt(msg`3D Shapes`),
  [TWODSHAPE]: tt(msg`2D Shapes`),
  [SYMMTRANS_LOCN]: tt(msg`Symmetry, Transformation & Location`),
  [ANGLE]: tt(msg`Angles`),
  [GEOMETRICPROOFS]: tt(msg`Geometric Proofs`),
  [TIME]: tt(msg`Time`),
  [AREA]: tt(msg`Area`),
  [LENGTH]: tt(msg`Length`),
  [MASS]: tt(msg`Mass`),
  [VOLUME_CAPACITY]: tt(msg`Volume & Capacity`),
  [TEMPERATURE]: tt(msg`Temperature`),
  [PYTHAGORAS_TRIG]: tt(msg`Pythagoras & Trigonometry`),
  [MEAS_GENERAL]: tt(msg`General`)
};
